/*
 * Brando & Co - luxe scroll reveals.
 * Slow, intentional fade-and-rise as elements enter the viewport, with a gentle
 * per-group stagger. Targets are defined in base.css under `.luxe-motion`; this
 * script only flips them to `.luxe-in`. Respects reduced-motion and degrades to
 * fully-visible content if anything fails.
 */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // If the user prefers reduced motion, drop the flag so nothing is ever hidden.
  if (reduce.matches) {
    root.classList.remove('luxe-motion');
    return;
  }

  var SELECTOR = [
    '.eyebrow',
    '[class*="__eyebrow"]',
    '[class*="__heading"]',
    '[class*="__title"]',
    '[class*="__kicker"]',
    '[class*="__card"]',
    '[class*="__excerpt"]',
    '[class*="__desc"]',
    '[class*="__text"]',
    '[class*="__head-link"]',
    '[class*="__view-all"]'
  ].join(',');

  function init() {
    var scope = document.getElementById('MainContent') || document.body;
    var targets = Array.prototype.slice.call(scope.querySelectorAll(SELECTOR));
    if (!targets.length || !('IntersectionObserver' in window)) {
      // No observer support: reveal everything immediately.
      root.classList.remove('luxe-motion');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        // Reveal anything intersecting OR already scrolled above the viewport,
        // so content is never left stuck hidden when sections are skipped.
        var reveal = entries.filter(function (e) {
          return e.isIntersecting || e.boundingClientRect.top < 0;
        });
        // Stagger only the ones entering together, by reading order.
        reveal.sort(function (a, b) {
          return a.boundingClientRect.top - b.boundingClientRect.top;
        });
        reveal.forEach(function (entry, i) {
          var el = entry.target;
          if (entry.isIntersecting) {
            el.style.transitionDelay = Math.min(i * 70, 350) + 'ms';
          }
          el.classList.add('luxe-in');
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
    );

    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
